import { Component, ViewChild, ElementRef, Input } from '@angular/core';


@Component({
  selector: 'linked-code',
  templateUrl: 'script-convert.html'
})
export class ScriptConvertComponent {

  @Input()
  src: string;

  @Input()
  type: string;

  @Input()
  dataId: string;

  @Input()
  dataFormat: string;

  @Input()
  dataRelated: string;

  @ViewChild('script') script: ElementRef;

  constructor() { }

  convertToScript() {
    var element = this.script.nativeElement;
    var script = document.createElement("script");
    script.type = this.type ? this.type : "text/javascript";
    script.src = this.src;
    script.setAttribute("data-id", this.dataId);
    script.setAttribute("data-format", this.dataFormat)
    script.setAttribute("data-related", this.dataRelated)

    if (element.innerHTML) {
      script.innerHTML = element.innerHTML;
    }
    var parent = element.parentElement;
    parent.parentElement.replaceChild(script, parent);
  }

  ngAfterViewInit() {
    this.convertToScript();
  }
}



// WEBPACK FOOTER //
// ./src/components/script-convert/script-convert.ts